import classNames from 'classnames'

import { usePopover } from '@hooks/popover'
import { formatPrice } from '@utils/strings'
import { VenueLayoutSection, VenueLayoutTable } from 'types/model/venue-layout'
import { Venue } from 'types/model'
import { Popover } from '@elements/popover'
import { useCallback } from 'react'

export function VenueMapTable({
  venue,
  table,
  soldOut = false,
  section,
  selectedSection,
  onSectionSelect,
  sectionMinPrice,
}: {
  venue: Venue
  table: VenueLayoutTable
  soldOut?: boolean
  section?: VenueLayoutSection
  selectedSection?: VenueLayoutSection
  onSectionSelect?: (sel?: VenueLayoutSection) => void
  sectionMinPrice?: number
}) {
  const { setAnchorElement, ...popover } = usePopover({
    placement: 'top',
    flip: false,
    arrow: true,
    closeable: false,
    openOnAnchorHover: true,
    closeOnAnchorHoverExit: true,
  })

  const selectSection = useCallback(() => {
    if (soldOut) return
    onSectionSelect?.(section)
  }, [onSectionSelect, section, soldOut])

  const noAssociatedInventory = sectionMinPrice === undefined
  if (!section || noAssociatedInventory) return null
  return (
    <>
      <button
        ref={setAnchorElement}
        onClick={selectSection}
        style={{ left: `${table.xPos}%`, top: `${table.yPos}%` }}
        className={classNames(
          'peer w-4 h-4 p-0 m-0 sm:w-5 sm:h-5 absolute border-card border-2 transition ease-out duration-200 !origin-center z-0',
          {
            'bg-green-400 hover:scale-110 group-hover:!bg-primary-800': !soldOut,
            'bg-red-600 !cursor-not-allowed': soldOut,
            'bg-primary-500': section?.id === (selectedSection?.id ?? null),
            'rounded-full': table.type === 'ROUND',
            'rounded-sm': table.type === 'SQUARE',
            // 'w-5 h-5 sm:w-6 sm:h-6': table.size === 'LARGE',
            // 'w-4 h-4 sm:w-5 sm:h-5': table.size === 'MEDIUM',
            // 'w-3 h-3 sm:w-4 sm:h-4': table.size === 'SMALL'
          }
        )}
      >
        <div
          className={classNames(
            'absolute inset-0 inline-flex h-full w-full animate-blink !origin-center border-card border-2 z-[-1]',
            {
              'bg-green-400  group-hover:!bg-primary-800': !soldOut,
              'bg-red-600 !cursor-not-allowed': soldOut,
              'bg-primary-500': section?.id === (selectedSection?.id ?? null),
              'rounded-full': table.type === 'ROUND',
              'rounded-sm': table.type === 'SQUARE',
            }
          )}
        ></div>
      </button>
      <Popover {...popover.props}>
        <div className="flex flex-col items-center justify-center py-5 space-y-4 px-7">
          <span className="font-bold !text-md">{section.name}</span>
          {soldOut && <span className="!text-base sm:!text-md text-error">Sold Out</span>}{' '}
          {!soldOut && (
            <span className="!text-base sm:!text-md text-success">
              {formatPrice(sectionMinPrice, { currency: venue.currencyCode })}
            </span>
          )}
        </div>
      </Popover>
    </>
  )
}
